import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    serverCard: {
        backgroundColor: theme?.employeeLookup.serverCardBackground,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(0.5),
        padding: theme.spacing(0.5),
        cursor: 'pointer'
    },
    serverText: {
        color: theme?.employeeLookup.serverTextColor,
    },
    label: {
        color: theme?.employeeLookup?.textColor,
    },
    optional: {
        color: theme?.employeeLookup?.optional,
    },
    selectedBorder: {
        borderColor: theme?.employeeLookup?.selectedBorder,
        borderWidth: '1px',
        borderStyle: 'solid',
    }
}));

export default useStyles;
